import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LayoutStore } from 'angular-admin-lte';

@Injectable()
export class MenuService {

  private ready : boolean;
  
  constructor( private http: HttpClient, private layoutStore : LayoutStore) { 
    this.ready = false;
  }
  
  public fillMenu(theMenu : any): void {
      this.layoutStore.sidebarLeftMenu.subscribe(value => {
          while(value.length > 0) {
            value.pop();
          }
          for (var i = 0, len = theMenu.length; i < len; ++i) {
             value.push(theMenu[i]);
          }
      });
      this.ready = true;
  }  
    
  public loadMenu(): void {
    this.http.get('/ui-service/menu').subscribe(
        data => { 
          this.fillMenu(data);
        });
  }
  
  public isMenuReady() : boolean {
    return this.ready;
  }
}
